import { render, staticRenderFns } from "./ContactInfoPanel.vue?vue&type=template&id=872adc5c&scoped=true&"
import script from "./ContactInfoPanel.vue?vue&type=script&lang=js&"
export * from "./ContactInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./ContactInfoPanel.vue?vue&type=style&index=0&id=872adc5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872adc5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('872adc5c')) {
      api.createRecord('872adc5c', component.options)
    } else {
      api.reload('872adc5c', component.options)
    }
    module.hot.accept("./ContactInfoPanel.vue?vue&type=template&id=872adc5c&scoped=true&", function () {
      api.rerender('872adc5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/contacts/components/ContactInfoPanel.vue"
export default component.exports